import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

if (!baseURL) {
  console.warn(
    '[SwilShare] REACT_APP_API_BASE_URL is not set. API calls will fail. ' +
    'Copy .env.example to .env and set the value.'
  );
}

const apiClient = axios.create({
  baseURL: baseURL ?? '',
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message || error.message || 'An unexpected error occurred';
    return Promise.reject(new Error(message));
  }
);

export default apiClient;
